import { api } from '@/services'

export const list = (serviceReportId) => {
  return api.get(`/web/open/charge/quotes/${serviceReportId}`)
}

export const listItems = (quoteId) => {
  return api.get(`/web/open/charge/quote/${quoteId}`)
}

export const payment = (paymentData) => {
  return api.post('/web/open/charge/setChargePaymentMethod', paymentData)
}

export const checkCharge = (chargeId) => {
  return api.get(`/web/open/charge/${chargeId}`)
}

export const acceptQuoteItems = (body) => {
  return api.post('/web/quote/acceptItems', body)
}
